import { NavigationField } from '@/components/NavigationField/NavigationField';
import type {
  SpeciesSearchField as SpeciesSearchFieldType,
  ReportFormData,
} from '@/screens/ReportCreation/reportCreation.types';
import { useLocalSearchParams, useRouter, useSegments } from 'expo-router';
import { useFormContext } from 'react-hook-form';
import { CreateReportDtoAnimalType } from '@api/WhisApi/generated';

interface SpeciesSearchFieldProps {
  field: SpeciesSearchFieldType;
  value?: string;
  displayValue?: string;
}

export const SpeciesSearchField = ({
  field,
  value,
  displayValue,
}: SpeciesSearchFieldProps): React.ReactElement => {
  const router = useRouter();
  const segments = useSegments() as string[];
  const { reportId } = useLocalSearchParams<{ reportId?: string }>();
  const { getValues } = useFormContext<ReportFormData>();

  const isEditRoute =
    segments.includes('reports') && segments.includes('edit') && reportId;
  const isBoardRoute = segments.includes('board');

  const handlePress = (): void => {
    if (isEditRoute && reportId) {
      const editBasePath = isBoardRoute
        ? '/(tabs)/board/reports/[reportId]/edit/species'
        : '/(tabs)/reports/[reportId]/edit/species';

      router.push({
        pathname: editBasePath,
        params: {
          reportId,
          ...(value ? { currentValue: value } : undefined),
        },
      });
      return;
    }

    // Build params for report-creation route
    const params: Record<string, string> = {};
    const formValues = getValues();

    if (value) {
      params.currentValue = value;
    }
    if (formValues.animalType === CreateReportDtoAnimalType.vertebrate) {
      params.animalType = CreateReportDtoAnimalType.vertebrate;
    }

    router.push({
      pathname: '/(tabs)/report-creation/species',
      params,
    });
  };

  return (
    <NavigationField
      label={field.label}
      placeholder={field.placeholder}
      value={displayValue}
      required={field.required}
      onPress={handlePress}
    />
  );
};
